// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"buildcontrols_BuildControls__PrGKQ","OrderButton":"buildcontrols_OrderButton__17qpl","enable":"buildcontrols_enable__vEuCb"};